import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useGetUserQuery } from "../../query/usersQuery";
import { UserRole } from "@KassaroAB/shared/types/enums/UserRole";
import { LoadingContainer } from "../../components/LoadingContainer";

interface AdminGuardProps {
  children: React.ReactNode;
}

export const AdminGuard = ({ children }: AdminGuardProps) => {
  const { t } = useTranslation();
  const { data: user, isLoading } = useGetUserQuery();

  if (isLoading || !user) {
    return <LoadingContainer message={t("common.loading")} />;
  }

  if (user.role !== UserRole.ADMIN) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
